// extracted by mini-css-extract-plugin
export default {"invoiceButtons":"style_invoiceButtons__m69ng"};